import styled from 'styled-components';

export const Container = styled.nav`
  z-index: 2;
  position: fixed;
  top: 0px;
  left: ${(props) => (props.visible ? 0 : -360)}px;

  width: auto;
  height: 100vh;
  background-color: #fff;
  transition: all 0.5s;
  padding: 20px;
  box-shadow: 0px 0px 6px 0px lightgrey;
  border-bottom-right-radius: 10px;

  > div:nth-of-type(1) {
    margin: 20px;
  }

  ul {
    list-style: none;
    margin: 20px;

    li {
      display: flex;
      align-items: center;
      margin: 12px 10px 12px 10px;
      cursor: pointer;
      width: fit-content;

      img {
        width: 20px;
      }

      span {
        font-family: 'Montserrat';
        font-size: 1.4rem;
        color: var(--green24);
        margin-left: 20px;
      }
    }
  }

  @media (max-width: 480px) {
    > div:nth-of-type(1) {
      margin: 10px;
    }

    ul {
      margin: 10px;
    }
  }

  @media (min-width: 1024px) {
    display: none;
  }
`;

export const Row = styled.div`
  display: flex;
`;

export const MenuIcon = styled.div`
  &.menu-icon {
    cursor: pointer;

    div {
      width: 40px;
      height: 6px;
      margin-bottom: 4px;
      background-color: var(--green00);
    }

    @media (min-width: 1024px) {
      display: none;
    }
  }
`;

export const Logo = styled.img`
  cursor: pointer;
  width: 120px;
  height: auto;
  margin-left: 20px;
`;
